import { http } from "../../../shared/api/http"

export type CourseVacancyItem = {
  id: string
  title: string
  salary_to: number | null
  salary_currency: string | null
  employment_type: string | null
  work_format: string | null
}

export type AvailableCourseVacancyItem = CourseVacancyItem & {
  is_selected: boolean
}

export type AvailableCourseVacanciesResponse = {
  items: AvailableCourseVacancyItem[]
  total: number
}

export const listAvailableCourseVacanciesApi = (
  courseId: string,
  params: { search?: string; limit?: number; offset?: number } = {}
) =>
  http.get<AvailableCourseVacanciesResponse>(
    `/api/mentor/courses/${courseId}/vacancies/available`,
    { params }
  )

export const saveCourseVacanciesApi = (courseId: string, vacancyIds: string[]) =>
  http.patch<{ success: boolean }>(
    `/api/mentor/courses/${courseId}/vacancies`,
    { vacancy_ids: vacancyIds }
  )

export type CourseVacanciesResponse = {
  items: CourseVacancyItem[]
  total: number
}

export const listCourseVacanciesApi = (courseId: string) =>
  http.get<CourseVacanciesResponse>(`/api/courses/${courseId}/vacancies`)